/*import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { BehaviorSubject } from 'rxjs';*/

import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Auth } from 'aws-amplify';

declare var $: any;
/*@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(private auth: AuthService, private router: Router,) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const roles = next.data['roles'];
    let accessRol = this.auth.isAccessUser(roles);
    if(!accessRol){
      this.router.navigateByUrl('/acceso-denegado');
      return;
    }
    return this.auth.isLoggedIn.pipe(
        take(1),
        map((isLoggedIn: boolean) => {
          $( "body" ).removeClass( "sidebar-collapse" );
          if (!isLoggedIn) {
            localStorage.clear();
            this.loggedIn.next(false);
            this.router.navigate(['/login']);
            return false;
          }
          return true;
        })
      );
  }
  
}*/

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  try {
    await Auth.currentAuthenticatedUser();
    console.log('User is authenticated');
    return true;
  } catch (error) {
    console.log('User is not authenticated');
    router.navigate(['/auth']);
    return false;
  }
};
